import { TranslateService } from "@ngx-translate/core";
import { Component, Input, OnInit } from "@angular/core";
import { ReportTaskService } from "../report-task.service";
import { ReportTask } from "../report-task.model";
import { ModalController } from "@ionic/angular";
import { UserService } from "src/app/_services";
import { UserBasic } from "src/app/_models/user.model";
import { HeaderModel } from "src/app/_component/header/header.model";
import { ThisPlatform } from "src/app/_services/platform.service";

@Component({
  selector: "app-add-report-task",
  templateUrl: "./add-report-task.page.html",
  styleUrls: [
    "./add-report-task.page.scss",
    "./../../../../_styles/ion-grid-box.scss",
  ],
})
export class AddReportTaskPage implements OnInit {
  constructor(
    public reportTaskServ: ReportTaskService,
    private userServ: UserService,
    private modalController: ModalController,
    public p: ThisPlatform,
    private translate: TranslateService
  ) {}

  @Input()
  reportId: number;

  headerInit: HeaderModel = {
    title: "REPORT_TASK.ADD_TASK",
    backDefaultHref: "/app/report",
  };
  userMissing: boolean = false;

  reportTaskSaving = false;

  label = this.translate.instant("SELECT_USER") + "*";
  ngOnInit() {
    this.userServ.userBasic = new UserBasic();

    this.reportTaskServ.reportTask = new ReportTask();
  }

  Save() {
    this.reportTaskServ.reportTask.idUserAssignmentBy = this.userServ.userStorage.id;
    this.reportTaskServ.reportTask.idUserPerformedBy = this.userServ.userBasic.id;
    this.reportTaskServ.reportTask.idReport = this.reportId;
    this.reportTaskServ.reportTask.status = 0;

    if (this.reportTaskServ.reportTask.idUserPerformedBy == undefined) {
      this.userMissing = true;
    } else {
      this.reportTaskSaving = true;
      this.userMissing = false;
      this.reportTaskServ.createReportTask().subscribe((res) => {
        this.reportTaskSaving = false;
        this.close();
      });
    }
  }

  isMissing(event) {
    if (event.length === 0) {
      this.userMissing = true;
    } else {
      this.userMissing = false;
    }
  }

  close() {
    this.modalController.dismiss();
  }
}
